import React from "react";
import { TextField } from "@material-ui/core";
import Autocomplete, {
	createFilterOptions
} from "@material-ui/lab/Autocomplete";
import classNames from "classnames";
import StreamStyles from "../styles/StreamStyles";
import StreamMarkerFbOption from "./StreamMarkerFbOption";
import {
	getFormattedTime,
	getPlayNumber
} from "../../football/components/utils/PlayUtils";
import VirtualizedList from "./VirtualizedList";

const VirtualizedListbox = React.forwardRef((props, ref) => {
	const { children, onMouseDown } = props;
	const classes = StreamStyles();

	const rowRenderer = (item) => {
		return item;
	};

	return (
		<VirtualizedList
			ref={ref}
			onMouseDown={onMouseDown}
			items={children}
			rowRenderer={rowRenderer}
			className={classes.streamMkrPlaySelectorListbox}
		/>
	);
});

const StreamMarkerPlaySelector = ({
	footballPlays,
	gameConfig,
	value,
	handleChange,
	error,
	errorMessage
}) => {
	const classes = StreamStyles();

	const filterOptions = createFilterOptions({
		matchFrom: "any",
		ignoreCase: true,
		stringify: (option) => {
			const play = footballPlays.find(({ id }) => id === option) || {};
			return `${getPlayNumber(play.index)} ${getFormattedTime(
				play.time,
				gameConfig,
				play.period
			)} ${play.title.trim()}`;
		}
	});

	return (
		<Autocomplete
			ListboxComponent={VirtualizedListbox}
			className={classNames({
				[classes.streamMkrCreateHiddenInput]: !!value
			})}
			classes={{ popper: classes.streamMkrCreatePlaysPopper }}
			filterOptions={filterOptions}
			options={footballPlays.map((p) => p.id)}
			renderInput={(params) => {
				const { value: playId } = params.inputProps || {};
				return (
					<TextField
						{...params}
						error={error}
						helperText={errorMessage}
						label="Play"
						variant="outlined"
						id="playId"
						name="playId"
						size="small"
						InputProps={{
							...params.InputProps,
							startAdornment: playId ? (
								<StreamMarkerFbOption
									play={footballPlays.find(({ id }) => id === playId)}
									gameConfig={gameConfig}
								/>
							) : undefined
						}}
					/>
				);
			}}
			renderOption={(v) => (
				<StreamMarkerFbOption
					play={footballPlays.find(({ id }) => id === v)}
					gameConfig={gameConfig}
				/>
			)}
			onChange={handleChange}
			value={value}
		/>
	);
};

export default StreamMarkerPlaySelector;
